import { router, usePage } from "@inertiajs/react";
import { logout, updateOrCreateUserPreference } from "../../../config/apisauce";
import { addRemoveArray } from "../../../helpers/arrayHelper";
import useStore from "../../../states/store";
import { useQueryClient } from "@tanstack/react-query";

export const useCreateUserPreference = () => {
  const [{ userPreference }, { setUserPreference }] = useStore();
  const { auth } = usePage().props;

  const createUserPreference = async (isSelected, id) => {
    const currentSavedProfiles = userPreference?.saved_profiles ?? [];
    const savedProfiles = Array.isArray(id) ? id.reduce(
      (updatedProfiles, itemId) => addRemoveArray(updatedProfiles, !isSelected, itemId),
      currentSavedProfiles
    ) : addRemoveArray(currentSavedProfiles, !isSelected, id);
    const params = {
      ...userPreference,
      saved_profiles: savedProfiles,
    };
    const response = await updateOrCreateUserPreference({
      user_id: auth?.user?.id,
      preferences: params,
    });
    if (response.ok) {
      setUserPreference(params);
    }
  };
  return createUserPreference;
};

export const useLogoutUser = () => {
  const [, { clearStore }] = useStore();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    const response = await logout();
    if (response.ok) {
      router.visit('/');
      clearStore();
      queryClient.resetQueries();
    }
  };
  return handleLogout;
};

export const removeNullValues = (data) => {
  return Object.keys(data).filter(key => data[key] !== "" && data[key] !== null);
};

export const formatCategoryValues = (data) => {
  return data?.reduce((acc, { categories_id, value }) => {
    acc[categories_id] = value;
    return acc;
  }, {});
};